import styled from 'styled-components';

import { FolderIcon, OtherVertIcon } from '@genially/icons';

import { BasicParagraph } from '../../foundations/typefaces/BasicParagraph';
import style from '../../style';

interface CenterContainerProps {
  hasRightComponent: boolean;
}

export const StyledBasicParagraph = styled(BasicParagraph)(
  ({ theme: { color, transition } }) => ({
    color: color.content.secondary.default(),
    transition: transition.standard('color'),
    ...style.mixins.ellipsis(true),
  }),
);

export const StyledDefaultFolderIcon = styled(FolderIcon)(
  ({ theme: { color, transition } }) => ({
    color: color.content.secondary.default(),
    transition: transition.standard('color'),
  }),
);

export const Wrapper = styled.div(({ theme: { size, color, transition } }) => ({
  background: color.background.quaternary.default(),
  borderRadius: size.units(0.5),
  width: '100%',
  height: size.units(5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  transition: transition.standard('background', 'color'),

  ...style.mixins.devices.desktop({
    '&:hover': {
      background: color.background.quaternary.hover(),

      [StyledBasicParagraph]: {
        color: color.content.secondary.hover(),
      },

      [StyledDefaultFolderIcon]: {
        color: color.content.secondary.hover(),
      },
    },
  }),
}));

export const LeftContainer = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  width: size.units(2),
}));

export const ActionContainer = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  cursor: 'pointer',
  minWidth: 0,
  paddingLeft: size.units(1.5),
}));

export const CenterContainer = styled.div<CenterContainerProps>(
  ({ theme: { size }, hasRightComponent }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    paddingRight: hasRightComponent ? 0 : size.units(1.5),
  }),
);

export const NameContainer = styled.div(({ theme: { size } }) => ({
  paddingLeft: size.units(1.5),
  minWidth: 0,
}));

export const StyledOtherVertIcon = styled(OtherVertIcon)(
  ({ theme: { color, transition } }) => ({
    color: color.content.secondary.default(),
    transition: transition.standard('color'),
  }),
);

export const ContainerRightIcon = styled.div(({ theme: { size, color } }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: size.units(1.5),
  width: size.units(2),
  height: size.units(2),

  '&:hover': {
    [StyledOtherVertIcon]: {
      color: color.content.secondary.hover(),
    },
  },
}));
